import { PropFormikField } from "constant/prop-types";
import PropTypes from "prop-types";
import React from "react";
import { FormControl } from "react-bootstrap";

function StringField(props) {
  const { field, type, ...rest } = props;

  return (
    <FormControl
      {...rest}
      name={field.name}
      onChange={field.onChange}
      type={type}
      value={field.value ? field.value : ""}
    />
  );
}

StringField.propTypes = {
  field: PropFormikField.isRequired,
  type: PropTypes.string,
};

StringField.defaultProps = {
  type: "text",
};

export { StringField };
